import table from "./table.json";
import pixTypeInput from "./pix-type-input.json";
import basicComponents from "./components.json";
import tableEmptyState from "./table-empty-state.json";
import periodDropdown from "./period-dropdown.json";
import pixKeyType from "./pix-key-type.json";
import addBillModalForm from "./add-bill-modal-form.json";
import addProduct from "./add-product.json";
import ballStatusIndicator from "./ball-status-indicator.json";
import coalaAddMenuModal from "./coala-add-menu-modal.json";
import coalaAddMenuProductModal from "./coala-add-menu-product-modal.json";
import coalaAddProductModal from "./coala-add-product-modal.json";
import coalaCategorizedProductsTable from "./coala-categorized-products-table.json";
import coalaMassEditModal from "./coala-mass-edit-modal.json";
import confirmModal from "./confirm-modal.json";
import consolidatedHistory from "./consolidated-history.json";
import containers from "./containers.json";
import dataTable from "./data-table.json";
import dialogs from "./dialogs.json";
import errorBoundary from "./error-boundary.json";
import eventTag from "./event-tag.json";
import formStatus from "./form-status.json";
import forms from "./forms.json";
import globalWarnings from "./global-warnings.json";
import helpers from "./helpers.json";
import hierarchicalChartAccountsSelector from "./hierarchical-chart-accounts-selector.json";
import monthPicker from "./month-picker.json";
import notAvailable from "./not-available.json";
import notification from "./notification.json";
import openSalesReport from "./open-sales-report.json";
import paginator from "./paginator.json";
import placeCheckbox from "./place-checkbox.json";
import pendingContracts from "./pending-contracts.json";
import placeFilter from "./place-filter.json";
import reportNavbar from "./report-navbar.json";
import reportTab from "./report-tab.json";
import reportTabs from "./report-tabs.json";
import selectImage from "./select-image.json";
import tabsBackoffice from "./tabs-backoffice.json";
import transactionalHistory from "./transactional-history.json";
import withdrawsCards from "./withdraws-cards.json";
import reportPrintTemplate from "./report-print-template.json";
import inputFile from "./input-file.json";
import notifications from "./notifications.json";
import header from "./header.json";
import xlsx from "./xlsx.json";
import importXlsxDrawer from "./import-xlsx-drawer.json";
import datahubChat from "./datahub-chat.json";

export const components = {
	...basicComponents,
	tableEmptyState,
	periodDropdown,
	pixKeyType,
	addBillModalForm,
	addProduct,
	ballStatusIndicator,
	confirmModal,
	coalaAddMenuModal,
	coalaAddMenuProductModal,
	coalaAddProductModal,
	coalaCategorizedProductsTable,
	coalaMassEditModal,
	consolidatedHistory,
	containers,
	dataTable,
	dialogs,
	errorBoundary,
	eventTag,
	formStatus,
	forms,
	globalWarnings,
	helpers,
	"hierarchical-chart-accounts-selector": hierarchicalChartAccountsSelector,
	monthPicker,
	notAvailable,
	notification,
	openSalesReport,
	paginator,
	placeCheckbox,
	pendingContracts,
	placeFilter,
	reportNavbar,
	reportTab,
	reportTabs,
	selectImage,
	table,
	tabsBackoffice,
	transactionalHistory,
	withdrawsCards,
	reportPrintTemplate,
	inputFile,
	notifications,
	header,
	pixTypeInput,
	xlsx,
	importXlsxDrawer,
	datahubChat,
	bonusReportTotalizers: {
		receivedValue: "Valeur totale accordée",
		spentValue: "Produits payés avec bonus",
		tipValue: "Service payé avec bonus",
		spentInOtherEvent: "Ventes payées avec bonus à une autre période",
		spentTipValueInOtherEvent: "Service payé avec bonus à une autre période",
		receivedValueTooltip: "Total des bonus accordés pendant la période filtrée",
		spentValueTooltip: "Total des produits payés avec bonus pendant la période filtrée",
		tipValueTooltip: "Total des services payés avec bonus pendant la période filtrée",
		spentInOtherEventTooltip:
			"Total des bonus accordés pendant la période filtrée et utilisés à une période différente sans considérer le service",
		spentTipValueInOtherEventTooltip:
			"Total des services payés avec bonus accordé pendant la période filtrée et utilisés à une période différente",
	},
};
